import axios from "axios";

export interface InstantSwapMeal {
  _id: string;
  name: string;
  image?: string;
  isActive?: boolean;
  refDrinkId?: string | null;
  categoryId?: { _id: string; name: string; displayOrder?: number } | null;
}
export interface InstantSwapEntry { mealId: InstantSwapMeal | null; active: boolean }

const API_URL = process.env.REACT_APP_API_URL || "";

const swapSetsApi = {
  getInstantCatalogue: async () => {
    const response = await axios.get(`${API_URL}/api/admin/swap-sets/instant-catalogue`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });
    return response.data as InstantSwapMeal[];
  },
  getSwapSetForDate: async (date: string) => {
    const response = await axios.get(`${API_URL}/api/admin/swap-sets/for-date`, {
      params: { date },
      headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });
    return response.data;
  },
  getSwapSets: async () => {
    const response = await axios.get(`${API_URL}/api/admin/swap-sets`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  getSwapSetById: async (id: string) => {
    const response = await axios.get(`${API_URL}/api/admin/swap-sets/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  updateSwapSet: async (id: string, data: any) => {
    const response = await axios.put(
      `${API_URL}/api/admin/swap-sets/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },
};

export default swapSetsApi;
